import { GeometryType } from "@evergis/api";
import React, { FC, useCallback, useMemo } from "react";
import { IconToggle, IJSXOption } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { EditGeometryType } from "../../../../evergis/core/attributes/geometryTypes";

import { SortByGeometryContainer } from "./styled";

import { useFilter } from "../../hooks/useFilter";
import { getGeometryFilter, getServiceTypeFilter } from "../../../../ducks/catalog/selectors";
import { setGeometryFilter, setServiceTypeFilter } from "../../../../ducks/catalog/catalog";

export const SortByGeometry: FC = () => {
  const { t } = useTranslation();
  const [filter, updateFilter] = useFilter(getGeometryFilter, setGeometryFilter);
  const [typeFilter, updateTypeFilter] = useFilter(getServiceTypeFilter, setServiceTypeFilter);

  const sortingOptions: IJSXOption[] = useMemo(
    () => [
      {
        value: "point",
        text: t("points", { ns: "common" }),
        icon: "geom_point",
      },
      {
        value: "polyline",
        text: t("lines", { ns: "common" }),
        icon: "geom_polyline",
      },
      {
        value: "polygon",
        text: t("polygons", { ns: "common" }),
        icon: "geom_polygon",
      },
      {
        value: EditGeometryType.Raster,
        text: t("raster", { ns: "common" }),
        icon: "geom_raster",
      },
      {
        value: GeometryType.Unknown,
        text: t("withoutGeometry", { ns: "common" }),
        icon: "geom_unknown",
      },
    ],
    [t],
  );

  const onSelect = useCallback(
    value => {
      if (value === EditGeometryType.Raster) {
        return typeFilter.includes("PostgresTileLayerService")
          ? updateTypeFilter([])
          : updateTypeFilter(["PostgresTileLayerService"]);
      }

      if (filter.split(",").includes(value)) {
        updateFilter("");
        updateTypeFilter([]);
      } else {
        updateFilter([{ value }].map(type => type.value).join(","));
        updateTypeFilter(["PostgresLayerService"]);
      }
    },
    [filter, updateFilter, typeFilter, updateTypeFilter],
  );

  return (
    <SortByGeometryContainer>
      {sortingOptions.map(({ icon, text, value }) => (
        <IconToggle
          key={value}
          kind={icon}
          title={text as unknown as string}
          isSelected={
            filter.split(",").includes(value) ||
            (value === EditGeometryType.Raster && typeFilter.includes("PostgresTileLayerService"))
          }
          onClick={() => onSelect(value)}
        />
      ))}
    </SortByGeometryContainer>
  );
};
